/*
  viral-product.js
  Product page helpers for the viral_* blocks of sections/main-product.liquid. Loaded with `defer`, after
  constants.js / pubsub.js / global.js (layout/theme.liquid), so `subscribe` and `PUB_SUB_EVENTS` exist.

  <viral-price-note>
  Dawn's product-info.js re-renders the section on variant change but only swaps a fixed list of nodes
  (#price-*, #Sku-*, #Inventory-*, #Volume-*, #Price-Per-Item-*). The Omnibus note is a block of its own, so it
  listens to the same `variantChange` event Dawn publishes (it carries the parsed, freshly rendered section HTML)
  and copies its state from there. Liquid stays the single source of truth for "is there a crossed-out price".
  No user-facing strings live in this file.
*/
if (!customElements.get('viral-price-note')) {
  customElements.define(
    'viral-price-note',
    class ViralPriceNote extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      /* Section id as rendered by Liquid. Inside quick add Dawn prefixes ids with "quickadd-" and keeps the
         original one in data-original-section; the fetched HTML always uses the original id. */
      get sectionId() {
        const productInfo = this.closest('product-info');
        return productInfo?.dataset.originalSection || productInfo?.dataset.section;
      }

      onVariantChange({ data }) {
        if (!data?.html || data.sectionId !== this.sectionId) return;

        /* A quick-add modal opened on a product page shares the host page's section id (Dawn keeps it in
           data-original-section), so the section id alone cannot tell the two products apart: also compare
           the product the fresh HTML was rendered for. */
        const ownProductId = this.closest('product-info')?.dataset.productId;
        const sourceProductId = data.html.querySelector('product-info')?.dataset.productId;
        if (ownProductId && sourceProductId && ownProductId !== sourceProductId) return;

        const source = data.html.getElementById(`ViralPriceNote-${data.sectionId}`);
        if (!source) return;

        this.innerHTML = source.innerHTML;
        this.hidden = source.hasAttribute('hidden');
      }
    }
  );
}
